import axios from 'axios';
import { store } from '../redux/store';
import { logout } from '../redux/slices/authSlice';
import { getToken, removeToken } from '../utils/storageUtils';
import alertify from 'alertifyjs';

// Create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: 60000, // 60 seconds for normal requests
  maxContentLength: 50 * 1024 * 1024, // 50MB for base64 images in templates
  maxBodyLength: 50 * 1024 * 1024, // 50MB for base64 images in templates
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: Add JWT token to all requests
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor: Handle errors globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized (token expired/invalid)
    if (error.response?.status === 401) {
      // Auto-logout
      removeToken();
      store.dispatch(logout());
      alertify.error('Oturum süreniz doldu. Lütfen tekrar giriş yapın.');
      
      // Redirect to login (if not already there)
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    // Handle network errors
    if (!error.response) {
      alertify.error('Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.');
    }
    
    // Handle server errors (5xx)
    if (error.response?.status >= 500) {
      alertify.error('Sunucu hatası. Lütfen daha sonra tekrar deneyin.');
    }
    
    return Promise.reject(error);
  }
);

export default api;

